import { Injectable } from "@angular/core";

import { BaseDataSource } from "../shared/_base.datasource";
import { Observable } from "rxjs";
import { ShortCodeService } from "../../../services/operator/shortcode.service";
import { ShortCode } from "../../types/shared/shortcode.type";

@Injectable()
export class ShortCodeDatasource extends BaseDataSource<ShortCode> {
    constructor(private service: ShortCodeService) {
        super(service);
    }

    create(data: ShortCode): Observable<boolean> {
        return this.service.create(data);
    }

    delete(id: number, companyId?: number): Observable<boolean> {
        return this.service.delete(id, companyId);
    }

    update(data: ShortCode): Observable<boolean> {
        return this.service.update(data);
    }

    getList(operatorId?: number) {
        const self = this;

        if (!self.service) {
            return;
        }

        self.loading = true;

        self.service.getList(self.filter, operatorId).subscribe((res) => {
            self.rows = res.rows;
            self.count = res.count;
            self.loading = false;
        });
    }

    getListInside(operatorId?: number) {
        const self = this;

        if (!self.service) {
            return;
        }

        self.loading = true;

        return self.service.getList(self.filter, operatorId);
    }
}
